import { createStyles, makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

const style = createStyles({
  buttonBase: {
    margin: "4px 0 24px 0",
    width: "500px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  button: {
    marginRight: "12px",
    width: "120px"
  },
  btnCancel: {
    backgroundColor: "#bfbfbf",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#999999",
    },
  },
});

export const styles = (theme: Theme) => createStyles(style);
export const useStyles = makeStyles(style);
